import calculateHorizontalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfView'
import calculateVerticalFieldOfView from 'helpers/calculations/calculateVerticalFieldOfView'
import calculateVerticalAngleOfView from 'helpers/calculations/calculateVerticalAngleOfView'
import calculatePpf from 'helpers/calculations/calculatePpf'
import calculateAngleOfViewFromFocalLength from 'helpers/calculations/calculateAngleOfViewFromFocalLength'

/**
 * Calculates the imager size and dependents ppf, horizontal field of view, and angle of view.
 * @param {Object} camera - The current camera being updated.
 * @param {String} imagerSize - The imager size to apply and calculate with.
 * @return {Object} The camera passsed in with updated attributes.
*/

export default function updateImagerSize(camera, imagerSize) {
  const { focalLength, horizontalResolution, distanceToTarget, aspectRatio, model } = camera
  // Convert to Number here since no validation occurs
  const parsedImagerSize = parseFloat(imagerSize)

  const horizontalAngleOfView = calculateAngleOfViewFromFocalLength({ imagerSize: parsedImagerSize, focalLength })
  const horizontalFieldOfView = calculateHorizontalFieldOfView({ horizontalAngleOfView, distance: distanceToTarget })

  return Object.assign({}, camera, {
    imagerSize: parsedImagerSize,
    horizontalAngleOfView,
    horizontalFieldOfView,
    ppf: calculatePpf({ horizontalResolution, horizontalFieldOfView, model, distance: distanceToTarget }),
    verticalAngleOfView: calculateVerticalAngleOfView({ horizontalAngleOfView, aspectRatio }),
    verticalFieldOfView: calculateVerticalFieldOfView({ horizontalFieldOfView, aspectRatio })
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateImagerSize.js